import {Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export {StyledContainer};
